import "src/containers/Terms/terms.scss";
import { toType } from "src/utils/helpers";
import { Text } from "src/containers/Terms/TermsScreen";

interface Props {
    data: any;
}

export const ConsentFormText = ({ data }: Props) => {
    return (
        <div>
            <ul style={{ listStyle: "none" }}>
                {Object.keys(data?.metadata).map((main, index) => (
                    <li key={"title_" + index}>
                        <div
                            style={{ marginBottom: "16px", fontWeight: "bold" }}
                        >
                            <Text weight="bold">{main}</Text>
                        </div>
                        <ul style={{ listStyle: "none" }}>
                            {Object.keys(data?.metadata[main]).map(
                                (secondary, i) =>
                                    toType(data?.metadata[main]) ===
                                    "object" ? (
                                        <li key={"list1_" + i}>
                                            {
                                                <div
                                                    style={{
                                                        marginBottom: "16px",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    <Text weight="bold">
                                                        {secondary}
                                                    </Text>
                                                </div>
                                            }
                                            {data?.metadata[main][
                                                secondary
                                            ].map((v: any) =>
                                                toType(v) === "string" ? (
                                                    <Text key={"text_" + index}>
                                                        {v}
                                                    </Text>
                                                ) : (
                                                    <ul
                                                        style={{
                                                            listStyle: "none",
                                                        }}
                                                    >
                                                        {v.map((vv: any) => (
                                                            <li
                                                                key={
                                                                    "list2_" +
                                                                    index
                                                                }
                                                            >
                                                                <Text>
                                                                    <span>
                                                                        •
                                                                    </span>
                                                                    {vv}
                                                                </Text>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )
                                            )}
                                        </li>
                                    ) : (
                                        <div
                                            style={{
                                                marginBottom: "16px",
                                            }}
                                            key={"sublist_" + i}
                                        >
                                            {toType(
                                                data?.metadata[main][secondary]
                                            ) === "string" ? (
                                                <Text>
                                                    {
                                                        data?.metadata[main][
                                                            secondary
                                                        ]
                                                    }
                                                </Text>
                                            ) : (
                                                <div>
                                                    <ul
                                                        style={{
                                                            listStyle: "none",
                                                        }}
                                                    >
                                                        {data?.metadata[main][
                                                            secondary
                                                        ].map((vv: any) => (
                                                            <li
                                                                key={
                                                                    "list3_" +
                                                                    index
                                                                }
                                                            >
                                                                <Text>
                                                                    <span>
                                                                        •
                                                                    </span>
                                                                    {vv}
                                                                </Text>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    )
                            )}
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    );
};
